export default __webpack_public_path__ + "static/media/Pizza.2fd5c979.png";